// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*

    - *** NOTICE ***
    - This file will be imported into lots of pages and components built with React and needs to be kept as lean as possible
    - *** NOTICE ***

    - To use the colors in css files, place this statement at the top of the component's CSS file
    - @value blue_primary from '../path/to/styles/colors.css';
    - Then use the var name wherever a color is needed like this; border: solid 1px blue_primary;

    - The connect color palette is using a plugin called postcss-icss-values
    - > docs: https://github.com/css-modules/postcss-icss-values

*/


/*  ======= NEW UX COLORS (2019) - being phased-in ======== */

/*  ====== THEME colors ====== */
    /* same as blue_primary    */
    /* same as darkui_accent_2 */

/*  ======= TEXT colors ======= */
    /* easer to remember/change */
    /* same as darkui_accent_2  */
    /* easer to remember/change */

/*  ======== ICON colors ====== */

    /* *** BLUE ICONS ***       */
    /* primary BLUE             */
    /* primary BLUE hover       */

    /* *** GRAY ICONS ***       */
    /* LIGHTER GRAY             */
    /* DARK GRAY was #222       */
    /* all GRAY hover           */


/*  ======= TRANSPARENT grays (from dark to light) ======== */
    /* #6c6c6c with 80% opacity */
    /* #6c6c6c with 50% opacity */
    /* #000000 with 10% opacity */
    /* #000000 with 50% opacity */
    /* #fbfbfb with 90% opacity */
    /* #ffffff with 25% opacity */
    /* #ffffff with 85% opacity */

/*  ======= TRANSPARENT blues ======== */
    /* #54a9fe with 50% opacity */
    /* #54a9fe with 30% opacity */


/*  ======= grays (from dark to light) ======== */

/*  =======  blues ======== */

/*  ======= reds ======== */

/*  ======= green ======== */

/*  ======= lime ======== */

/*  ======= teal ======== */

/*  ======= orange ======== */

/*  ======= yellow ======== */

/*  ======= violet ======== */

/*  ======= purple ======== */


/*  ======= below = OLD COLORS - being phased-out ======== */


/*  ======= Greys ======== */

/*  ======= Blues ======== */

/*  ======= Reds ======== */

/*  ======= Greens ======== */

/*  ======= Yellows ======== */

/*  ======= Oranges ======== */

/*  ======= Berries ======== */
`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/styles/colors.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;CAaC;;;AAGD,6DAA6D;;AAE7D,gCAAgC;IAC5B,4BAA4B;IAC5B,4BAA4B;;AAEhC,iCAAiC;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;;AAEjC,iCAAiC;;IAE7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;;IAE7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;;;AAGjC,6DAA6D;IACzD,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;;AAEjC,wCAAwC;IACpC,6BAA6B;IAC7B,6BAA6B;;;AAGjC,iDAAiD;;AAiBjD,6BAA6B;;AAU7B,2BAA2B;;AAS3B,4BAA4B;;AAS5B,2BAA2B;;AAS3B,2BAA2B;;AAS3B,6BAA6B;;AAS7B,6BAA6B;;AAS7B,6BAA6B;;AAS7B,6BAA6B;;;AAU7B,4DAA4D;;;AAG5D,4BAA4B;;AAmD5B,4BAA4B;;AA+B5B,2BAA2B;;AAY3B,6BAA6B;;AA0B7B,8BAA8B;;AAO9B,8BAA8B;;AAmB9B,8BAA8B","sourcesContent":["/*\n\n    - *** NOTICE ***\n    - This file will be imported into lots of pages and components built with React and needs to be kept as lean as possible\n    - *** NOTICE ***\n\n    - To use the colors in css files, place this statement at the top of the component's CSS file\n    - @value blue_primary from '../path/to/styles/colors.css';\n    - Then use the var name wherever a color is needed like this; border: solid 1px blue_primary;\n\n    - The connect color palette is using a plugin called postcss-icss-values\n    - > docs: https://github.com/css-modules/postcss-icss-values\n\n*/\n\n\n/*  ======= NEW UX COLORS (2019) - being phased-in ======== */\n\n/*  ====== THEME colors ====== */\n    /* same as blue_primary    */   @value primary:                 #1976d2;\n    /* same as darkui_accent_2 */   @value secondary:               #6c6c6c;\n\n/*  ======= TEXT colors ======= */\n    /* easer to remember/change */  @value textLight:               #fff;\n    /* same as darkui_accent_2  */  @value textMedium:              #6c6c6c;\n    /* easer to remember/change */  @value textDark:                #000;\n\n/*  ======== ICON colors ====== */\n\n    /* *** BLUE ICONS ***       */\n    /* primary BLUE             */  @value iconPrimary:             #1976d2;\n    /* primary BLUE hover       */  @value iconPrimaryHover:        #1265c2;\n\n    /* *** GRAY ICONS ***       */\n    /* LIGHTER GRAY             */  @value iconSecondary:           #6c6c6c;\n    /* DARK GRAY was #222       */  @value iconSecondaryDark:       #252525;\n    /* all GRAY hover           */  @value iconSecondaryHover:      #000;\n\n\n/*  ======= TRANSPARENT grays (from dark to light) ======== */\n    /* #6c6c6c with 80% opacity */  @value darkui_accent_2_80:      rgba(108, 108, 108, 0.8);\n    /* #6c6c6c with 50% opacity */  @value darkui_accent_2_50:      rgba(108, 108, 108, 0.5);\n    /* #000000 with 10% opacity */  @value black_10:                rgba(0, 0, 0, 0.1);\n    /* #000000 with 50% opacity */  @value black_50:                rgba(0, 0, 0, 0.5);\n    /* #fbfbfb with 90% opacity */  @value lightui_surface_1_90:    rgba(251, 251, 251, 0.9);\n    /* #ffffff with 25% opacity */  @value white_25:                rgba(255, 255, 255, 0.25);\n    /* #ffffff with 85% opacity */  @value white_85:                rgba(255, 255, 255, 0.85);\n\n/*  ======= TRANSPARENT blues ======== */\n    /* #54a9fe with 50% opacity */  @value blue_light_1_50:         rgba(84, 169, 254, 0.5);\n    /* #54a9fe with 30% opacity */  @value blue_light_1_30:         rgba(84, 169, 254, 0.3);\n\n\n/*  ======= grays (from dark to light) ======== */\n@value black:               #000;\n@value darkui_surface_1:    #101010;\n@value darkui_surface_2:    #1d1d1d;\n@value darkui_surface_3:    #252525;\n@value darkui_surface_4:    #3b3b3b;\n@value darkui_accent_1:     #515151;\n@value darkui_accent_2:     #6c6c6c;\n@value darkui_accent_3:     #a6a6a6;\n@value lightui_accent_2:    #c3c3c3;\n@value lightui_accent_1:    #d8d8d8;\n@value lightui_surface_4:   #e4e4e4;\n@value lightui_surface_3:   #efefef;\n@value lightui_surface_2:   #f4f4f4;\n@value lightui_surface_1:   #fbfbfb;\n@value white:               #fff;\n\n/*  =======  blues ======== */\n@value blue_dark_3:         #004ba0;\n@value blue_dark_2:         #0a59b2;\n@value blue_dark_1:         #1265c2;\n@value blue_dark_0          #1395FC;\n@value blue_primary:        #1976d2;\n@value blue_light_3:        #2a88e6;\n@value blue_light_2:        #3b97f3;\n@value blue_light_1:        #54a9fe;\n\n/*  ======= reds ======== */\n@value red_dark_3:          #b10d0d;\n@value red_dark_2:          #c21515;\n@value red_dark_1:          #d32020;\n@value red_primary:         #e02c2c;\n@value red_light_3:         #ee3e3e;\n@value red_light_2:         #f85454;\n@value red_light_1:         #ff6f6f;\n\n/*  ======= green ======== */\n@value green_dark_3:        #007838;\n@value green_dark_2:        #04873b;\n@value green_dark_1:        #0b963f;\n@value green_primary:       #16a544;\n@value green_light_3:       #28b44e;\n@value green_light_2:       #40c35d;\n@value green_light_1:       #60d275;\n\n/*  ======= lime ======== */\n@value lime_dark_3:         #74b816;\n@value lime_dark_2:         #82c91e;\n@value lime_dark_1:         #94d82d;\n@value lime_primary:        #a9e34b;\n@value lime_light_3:        #c0eb75;\n@value lime_light_2:        #d8f5a2;\n@value lime_light_1:        #e9fac8;\n\n/*  ======= teal ======== */\n@value teal_dark_3:         #0b7285;\n@value teal_dark_2:         #0c8599;\n@value teal_dark_1:         #1098ad;\n@value teal_primary:        #15aabf;\n@value teal_light_3:        #22b8cf;\n@value teal_light_2:        #3bc9db;\n@value teal_light_1:        #66d9e8;\n\n/*  ======= orange ======== */\n@value orange_dark_3:       #cf4a06;\n@value orange_dark_2:       #de5809;\n@value orange_dark_1:       #ea670e;\n@value orange_primary:      #f27716;\n@value orange_light_3:      #f98925;\n@value orange_light_2:      #fd9d39;\n@value orange_light_1:      #ffb154;\n\n/*  ======= yellow ======== */\n@value yellow_dark_3:       #e4a700;\n@value yellow_dark_2:       #edb312;\n@value yellow_dark_1:       #f5bf2a;\n@value yellow_primary:      #faca48;\n@value yellow_light_3:      #fdd66b;\n@value yellow_light_2:      #fedb7c;\n@value yellow_light_1:      #ffe18e;\n\n/*  ======= violet ======== */\n@value violet_dark_3:       #ac06bc;\n@value violet_dark_2:       #c00Fc4;\n@value violet_dark_1:       #cc1dc1;\n@value violet_primary:      #d42fc2;\n@value violet_light_3:      #de45c6;\n@value violet_light_2:      #e55ecb;\n@value violet_light_1:      #ed79d5;\n\n/*  ======= purple ======== */\n@value purple_dark_3:       #4f28c0;\n@value purple_dark_2:       #5a30d7;\n@value purple_dark_1:       #6439e4;\n@value purple_primary:      #6f42f3;\n@value purple_light_3:      #815af7;\n@value purple_light_2:      #9370f9;\n@value purple_light_1:      #aa8dfc;\n\n\n/*  ======= below = OLD COLORS - being phased-out ======== */\n\n\n/*  ======= Greys ======== */\n@value color_100: #222;\n@value color_101: #555;\n@value color_102: #888;\n@value color_103: #c7c7c7;\n@value color_104: #fafafa;\n@value color_105: #f9f9f9;\n@value color_106: #fff;\n@value color_107: #ddd;\n@value color_108: #ccc;\n@value color_109: #e5e5e5;\n@value color_110: #EDEDED;\n@value color_111: #a4a4a4;\n@value color_112: #333;\n@value color_113: #777;\n@value color_114: #999;\n@value color_115: #f2f2f2;\n@value color_116: #eaeaea;\n@value color_117: #212121;\n@value color_118: #eee;\n@value color_119: #bbb;\n@value color_120: #444;\n@value color_121: #0e334c;\n@value color_122: #C0C0C0;\n@value color_123: rgba(255,255,255,0.85);\n@value color_124: #f2f2f2;\n@value color_125: rgba(0,0,0,0.1);\n@value color_126: #E7E7E7;\n@value color_127: #dadada;\n@value color_128: #282828;\n@value color_129: rgba(163, 212, 250, 0.8);\n@value color_130: #e8e8e8;\n@value color_131: #000;\n@value color_132: #aaa;\n@value color_133: rgba(255, 255, 255, 0.25);\n@value color_134: #6e8594;\n@value color_135: rgba(110,133,148,.8);\n@value color_136: #d3d3d3;\n@value color_137: rgba(0, 0, 0, 0.1);\n@value color_138: #E0E0E0;\n@value color_139: #4A4A4A;\n@value color_140: #E6E6E6;\n@value color_141: rgba(250, 250, 250, 0.9);\n@value color_142: #D8D8D8;\n@value color_143: #6C6C6C;\n@value color_144: #515151;\n@value color_145: #F4F4F4;\n@value color_146: rgb(108, 108, 108);\n@value color_147: rgb(34, 34, 34);\n@value color_148: #595959;\n\n/*  ======= Blues ======== */\n@value color_200: #0c7cad;\n@value color_201: #11a9ed;\n@value color_202: #73d4ff;\n@value color_203: #abe5fc;\n@value color_204: #8fd6f7;\n@value color_205: #0d87bd;\n@value color_206: #16b7ef;\n@value color_207: #10a8ec;\n@value color_208: #c8ebfa;\n@value color_209: #3397ed;\n@value color_210: rgba(171, 229, 252, 0.8);\n@value color_211: #3FF1FF;\n@value color_212: #0D82B5;\n@value color_213: #13b2ea;\n@value color_214: #00a2ea;\n@value color_215: #e1f4fc;\n@value color_216: #216cc0;\n@value color_217: rgba(17, 169, 237, 1);\n@value color_218: #8CD3FA;\n@value color_219: #b0e1f7;\n@value color_220: #a9d4fe;\n@value color_221: #E6F2FF;\n@value color_222: #35F0F4;\n@value color_223: #1265c2;\n@value color_224: #10a9ed;\n@value color_225: #26b2f1;\n@value color_226: #1976D2;\n@value color_227: #54a9fe;\n@value color_228: #7ed9ff;\n\n/*  ======= Reds ======== */\n@value color_300: #BF0F24;\n@value color_301: #ff0035;\n@value color_302: #930d24;\n@value color_303: #c3072a;\n@value color_304: #BD142A;\n@value color_305: #FA516F;\n@value color_306: #B10D0D;\n@value color_307: #ffc5d2;\n@value color_308: #C92A2A;\n@value color_309: #DF4D18;\n\n/*  ======= Greens ======== */\n@value color_400: #2A894F;\n@value color_401: #50B012;\n@value color_402: #BBD86C;\n@value color_404: #D2FAB8;\n@value color_405: #C1F89D;\n@value color_406: #76FFE5;\n@value color_407: #9af144;\n@value color_408: #72EA24;\n@value color_409: #90E71B;\n@value color_410: #31D9C8;\n@value color_411: #eeffe3;\n@value color_412: #D6FF32;\n@value color_413: #B6D56B;\n@value color_414: #C0EB75;\n@value color_415: #94D82D;\n@value color_416: #74B816;\n@value color_417: #0AA476;\n@value color_418: #22B573;\n@value color_419: #11B886;\n@value color_420: #54E0B5;\n@value color_421: #289E3F;\n@value color_422: #0F6A37;\n@value color_423: rgba(80, 176, 18, 0.5);\n@value color_424: rgba(80, 176, 18, 0.03);\n\n/*  ======= Yellows ======== */\n@value color_500: #F8E700;\n@value color_501: #DAF200;\n@value color_502: #FDE37D;\n@value color_503: #FFFFEF;\n@value color_504: #EEBE1B;\n\n/*  ======= Oranges ======== */\n@value color_600: #FC9E31;\n@value color_601: #FF9E0D;\n@value color_602: #CC6300;\n@value color_604: #E9AE00;\n@value color_605: #ED7E00;\n@value color_606: #FFDD9E;\n@value color_607: #ffa910;\n@value color_608: #ff9406;\n@value color_609: #ffbc50;\n@value color_610: rgba(255, 188, 80, 1);\n@value color_611: rgba(255, 158, 13, 1);\n@value color_612: rgba(237, 126, 0, 1);\n@value color_613: #FED7A5;\n@value color_614: #FF841E;\n@value color_615: #FEAF5A;\n@value color_616: #F27019;\n@value color_617: #FF9735;\n\n/*  ======= Berries ======== */\n@value color_700: #632D5C;\n@value color_701: #CF23B8;\n@value color_702: #6439E4;\n@value color_703: #9C00FF;\n@value color_704: #DE33CB;\n@value color_705: #CF18C4;\n@value color_706: #DF88CD;\n@value color_707: #A606BC;\n@value color_708: #815AF7;\n@value color_709: #6F42F3;\n@value color_710: #ddc909;\n@value color_711: #d527c0;\n@value color_712: #ff5d7c;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary": `#1976d2`,
	"secondary": `#6c6c6c`,
	"textLight": `#fff`,
	"textMedium": `#6c6c6c`,
	"textDark": `#000`,
	"iconPrimary": `#1976d2`,
	"iconPrimaryHover": `#1265c2`,
	"iconSecondary": `#6c6c6c`,
	"iconSecondaryDark": `#252525`,
	"iconSecondaryHover": `#000`,
	"darkui_accent_2_80": `rgba(108, 108, 108, 0.8)`,
	"darkui_accent_2_50": `rgba(108, 108, 108, 0.5)`,
	"black_10": `rgba(0, 0, 0, 0.1)`,
	"black_50": `rgba(0, 0, 0, 0.5)`,
	"lightui_surface_1_90": `rgba(251, 251, 251, 0.9)`,
	"white_25": `rgba(255, 255, 255, 0.25)`,
	"white_85": `rgba(255, 255, 255, 0.85)`,
	"blue_light_1_50": `rgba(84, 169, 254, 0.5)`,
	"blue_light_1_30": `rgba(84, 169, 254, 0.3)`,
	"black": `#000`,
	"darkui_surface_1": `#101010`,
	"darkui_surface_2": `#1d1d1d`,
	"darkui_surface_3": `#252525`,
	"darkui_surface_4": `#3b3b3b`,
	"darkui_accent_1": `#515151`,
	"darkui_accent_2": `#6c6c6c`,
	"darkui_accent_3": `#a6a6a6`,
	"lightui_accent_2": `#c3c3c3`,
	"lightui_accent_1": `#d8d8d8`,
	"lightui_surface_4": `#e4e4e4`,
	"lightui_surface_3": `#efefef`,
	"lightui_surface_2": `#f4f4f4`,
	"lightui_surface_1": `#fbfbfb`,
	"white": `#fff`,
	"blue_dark_3": `#004ba0`,
	"blue_dark_2": `#0a59b2`,
	"blue_dark_1": `#1265c2`,
	"blue_dark_0": `#1395FC`,
	"blue_primary": `#1976d2`,
	"blue_light_3": `#2a88e6`,
	"blue_light_2": `#3b97f3`,
	"blue_light_1": `#54a9fe`,
	"red_dark_3": `#b10d0d`,
	"red_dark_2": `#c21515`,
	"red_dark_1": `#d32020`,
	"red_primary": `#e02c2c`,
	"red_light_3": `#ee3e3e`,
	"red_light_2": `#f85454`,
	"red_light_1": `#ff6f6f`,
	"green_dark_3": `#007838`,
	"green_dark_2": `#04873b`,
	"green_dark_1": `#0b963f`,
	"green_primary": `#16a544`,
	"green_light_3": `#28b44e`,
	"green_light_2": `#40c35d`,
	"green_light_1": `#60d275`,
	"lime_dark_3": `#74b816`,
	"lime_dark_2": `#82c91e`,
	"lime_dark_1": `#94d82d`,
	"lime_primary": `#a9e34b`,
	"lime_light_3": `#c0eb75`,
	"lime_light_2": `#d8f5a2`,
	"lime_light_1": `#e9fac8`,
	"teal_dark_3": `#0b7285`,
	"teal_dark_2": `#0c8599`,
	"teal_dark_1": `#1098ad`,
	"teal_primary": `#15aabf`,
	"teal_light_3": `#22b8cf`,
	"teal_light_2": `#3bc9db`,
	"teal_light_1": `#66d9e8`,
	"orange_dark_3": `#cf4a06`,
	"orange_dark_2": `#de5809`,
	"orange_dark_1": `#ea670e`,
	"orange_primary": `#f27716`,
	"orange_light_3": `#f98925`,
	"orange_light_2": `#fd9d39`,
	"orange_light_1": `#ffb154`,
	"yellow_dark_3": `#e4a700`,
	"yellow_dark_2": `#edb312`,
	"yellow_dark_1": `#f5bf2a`,
	"yellow_primary": `#faca48`,
	"yellow_light_3": `#fdd66b`,
	"yellow_light_2": `#fedb7c`,
	"yellow_light_1": `#ffe18e`,
	"violet_dark_3": `#ac06bc`,
	"violet_dark_2": `#c00Fc4`,
	"violet_dark_1": `#cc1dc1`,
	"violet_primary": `#d42fc2`,
	"violet_light_3": `#de45c6`,
	"violet_light_2": `#e55ecb`,
	"violet_light_1": `#ed79d5`,
	"purple_dark_3": `#4f28c0`,
	"purple_dark_2": `#5a30d7`,
	"purple_dark_1": `#6439e4`,
	"purple_primary": `#6f42f3`,
	"purple_light_3": `#815af7`,
	"purple_light_2": `#9370f9`,
	"purple_light_1": `#aa8dfc`,
	"color_100": `#222`,
	"color_101": `#555`,
	"color_102": `#888`,
	"color_103": `#c7c7c7`,
	"color_104": `#fafafa`,
	"color_105": `#f9f9f9`,
	"color_106": `#fff`,
	"color_107": `#ddd`,
	"color_108": `#ccc`,
	"color_109": `#e5e5e5`,
	"color_110": `#EDEDED`,
	"color_111": `#a4a4a4`,
	"color_112": `#333`,
	"color_113": `#777`,
	"color_114": `#999`,
	"color_115": `#f2f2f2`,
	"color_116": `#eaeaea`,
	"color_117": `#212121`,
	"color_118": `#eee`,
	"color_119": `#bbb`,
	"color_120": `#444`,
	"color_121": `#0e334c`,
	"color_122": `#C0C0C0`,
	"color_123": `rgba(255,255,255,0.85)`,
	"color_124": `#f2f2f2`,
	"color_125": `rgba(0,0,0,0.1)`,
	"color_126": `#E7E7E7`,
	"color_127": `#dadada`,
	"color_128": `#282828`,
	"color_129": `rgba(163, 212, 250, 0.8)`,
	"color_130": `#e8e8e8`,
	"color_131": `#000`,
	"color_132": `#aaa`,
	"color_133": `rgba(255, 255, 255, 0.25)`,
	"color_134": `#6e8594`,
	"color_135": `rgba(110,133,148,.8)`,
	"color_136": `#d3d3d3`,
	"color_137": `rgba(0, 0, 0, 0.1)`,
	"color_138": `#E0E0E0`,
	"color_139": `#4A4A4A`,
	"color_140": `#E6E6E6`,
	"color_141": `rgba(250, 250, 250, 0.9)`,
	"color_142": `#D8D8D8`,
	"color_143": `#6C6C6C`,
	"color_144": `#515151`,
	"color_145": `#F4F4F4`,
	"color_146": `rgb(108, 108, 108)`,
	"color_147": `rgb(34, 34, 34)`,
	"color_148": `#595959`,
	"color_200": `#0c7cad`,
	"color_201": `#11a9ed`,
	"color_202": `#73d4ff`,
	"color_203": `#abe5fc`,
	"color_204": `#8fd6f7`,
	"color_205": `#0d87bd`,
	"color_206": `#16b7ef`,
	"color_207": `#10a8ec`,
	"color_208": `#c8ebfa`,
	"color_209": `#3397ed`,
	"color_210": `rgba(171, 229, 252, 0.8)`,
	"color_211": `#3FF1FF`,
	"color_212": `#0D82B5`,
	"color_213": `#13b2ea`,
	"color_214": `#00a2ea`,
	"color_215": `#e1f4fc`,
	"color_216": `#216cc0`,
	"color_217": `rgba(17, 169, 237, 1)`,
	"color_218": `#8CD3FA`,
	"color_219": `#b0e1f7`,
	"color_220": `#a9d4fe`,
	"color_221": `#E6F2FF`,
	"color_222": `#35F0F4`,
	"color_223": `#1265c2`,
	"color_224": `#10a9ed`,
	"color_225": `#26b2f1`,
	"color_226": `#1976D2`,
	"color_227": `#54a9fe`,
	"color_228": `#7ed9ff`,
	"color_300": `#BF0F24`,
	"color_301": `#ff0035`,
	"color_302": `#930d24`,
	"color_303": `#c3072a`,
	"color_304": `#BD142A`,
	"color_305": `#FA516F`,
	"color_306": `#B10D0D`,
	"color_307": `#ffc5d2`,
	"color_308": `#C92A2A`,
	"color_309": `#DF4D18`,
	"color_400": `#2A894F`,
	"color_401": `#50B012`,
	"color_402": `#BBD86C`,
	"color_404": `#D2FAB8`,
	"color_405": `#C1F89D`,
	"color_406": `#76FFE5`,
	"color_407": `#9af144`,
	"color_408": `#72EA24`,
	"color_409": `#90E71B`,
	"color_410": `#31D9C8`,
	"color_411": `#eeffe3`,
	"color_412": `#D6FF32`,
	"color_413": `#B6D56B`,
	"color_414": `#C0EB75`,
	"color_415": `#94D82D`,
	"color_416": `#74B816`,
	"color_417": `#0AA476`,
	"color_418": `#22B573`,
	"color_419": `#11B886`,
	"color_420": `#54E0B5`,
	"color_421": `#289E3F`,
	"color_422": `#0F6A37`,
	"color_423": `rgba(80, 176, 18, 0.5)`,
	"color_424": `rgba(80, 176, 18, 0.03)`,
	"color_500": `#F8E700`,
	"color_501": `#DAF200`,
	"color_502": `#FDE37D`,
	"color_503": `#FFFFEF`,
	"color_504": `#EEBE1B`,
	"color_600": `#FC9E31`,
	"color_601": `#FF9E0D`,
	"color_602": `#CC6300`,
	"color_604": `#E9AE00`,
	"color_605": `#ED7E00`,
	"color_606": `#FFDD9E`,
	"color_607": `#ffa910`,
	"color_608": `#ff9406`,
	"color_609": `#ffbc50`,
	"color_610": `rgba(255, 188, 80, 1)`,
	"color_611": `rgba(255, 158, 13, 1)`,
	"color_612": `rgba(237, 126, 0, 1)`,
	"color_613": `#FED7A5`,
	"color_614": `#FF841E`,
	"color_615": `#FEAF5A`,
	"color_616": `#F27019`,
	"color_617": `#FF9735`,
	"color_700": `#632D5C`,
	"color_701": `#CF23B8`,
	"color_702": `#6439E4`,
	"color_703": `#9C00FF`,
	"color_704": `#DE33CB`,
	"color_705": `#CF18C4`,
	"color_706": `#DF88CD`,
	"color_707": `#A606BC`,
	"color_708": `#815AF7`,
	"color_709": `#6F42F3`,
	"color_710": `#ddc909`,
	"color_711": `#d527c0`,
	"color_712": `#ff5d7c`
};
export default ___CSS_LOADER_EXPORT___;
